import React from 'react'
import Sidebar from '../../../Components/Sidebar/Sidebar';
import { vectorOperatorSidebarItems } from './Routes'

const Navbar = () => {
    return <Sidebar sideBarItems={vectorOperatorSidebarItems} />
}

export default Navbar;